import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408ea721"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }),
  /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-primary" })
], -1))
const _hoisted_7 = { class: "ui-banners" }
const _hoisted_8 = { class: "ui-banner-header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Personalize os banners e aumente as interações com os seus clientes. ")
], -1))
const _hoisted_10 = { class: "ui-banner-card" }
const _hoisted_11 = { class: "ui-banner-card-topo" }
const _hoisted_12 = { class: "ui-banner-ordem" }
const _hoisted_13 = { class: "ui-move" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "ui-banner-grid" }
const _hoisted_16 = { class: "ui-banner-upload-area" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Imagem Desktop "),
  /*#__PURE__*/_createElementVNode("strong", null, "*")
], -1))
const _hoisted_18 = ["onClick", "onDrop"]
const _hoisted_19 = ["id", "onChange"]
const _hoisted_20 = {
  key: 0,
  class: "ui-upload-loading"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviando imagem...", -1))
const _hoisted_22 = {
  key: 1,
  class: "ui-banner-upload-placeholder"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviar imagem desktop", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "JPG, PNG ou WEBP", -1))
const _hoisted_25 = { class: "ui-banner-upload-area" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Imagem Mobile "),
  /*#__PURE__*/_createElementVNode("strong", null, "*")
], -1))
const _hoisted_27 = ["onClick", "onDrop"]
const _hoisted_28 = ["id", "onChange"]
const _hoisted_29 = {
  key: 0,
  class: "ui-upload-loading"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviando imagem...", -1))
const _hoisted_31 = {
  key: 1,
  class: "ui-banner-upload-placeholder"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviar imagem mobile", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "JPG, PNG ou WEBP", -1))
const _hoisted_34 = { class: "ui-banner-form" }
const _hoisted_35 = { class: "ui-banner-acoes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_card = _resolveComponent("card")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _hoisted_6
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.state.carregando,
          active: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_card, { titulo: " " }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.state.carregando
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse, {
                        activeKey: _ctx.state.accordionAberto,
                        "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.accordionAberto) = $event)),
                        accordion: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiposBanner, (tipoBanner) => {
                            return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                              key: tipoBanner.valor,
                              header: tipoBanner.descricao
                            }, {
                              extra: _withCtx(() => [
                                _createVNode(_component_a_tag, { color: "blue" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.obterBannersPorTipo(tipoBanner.valor).length) + " banner(s) ", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _hoisted_9,
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: _withModifiers(($event: any) => (_ctx.adicionarBanner(tipoBanner.valor)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Adicionar Banner ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _createVNode(_component_draggable, {
                                  modelValue: _ctx.state.bannersPorTipo[tipoBanner.valor],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.state.bannersPorTipo[tipoBanner.valor]) = $event),
                                  "item-key": "codigoTemporario",
                                  handle: ".ui-move",
                                  class: "ui-banner-lista",
                                  onEnd: ($event: any) => (_ctx.organizarBanners(tipoBanner.valor))
                                }, {
                                  item: _withCtx(({ element, index }) => [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_a_tooltip, {
                                            title: "Arrastar para ordenar",
                                            placement: "bottom"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", _hoisted_13, [
                                                _createVNode(_component_icone, { nome: "draggable" })
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("span", null, _toDisplayString(element.ordem) + "º Banner", 1)
                                        ]),
                                        _createVNode(_component_a_tooltip, {
                                          title: "Remover banner",
                                          color: "red",
                                          placement: "bottom"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("a", {
                                              class: "ui-remover-banner",
                                              onClick: ($event: any) => (_ctx.confirmaExclusao(tipoBanner.valor, element))
                                            }, [
                                              _createVNode(_component_icone, { nome: "excluir" })
                                            ], 8, _hoisted_14)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _hoisted_17,
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["ui-banner-upload", { 'ui-banner-upload-vazio': !element.imagemDesktop }]),
                                            onClick: ($event: any) => (_ctx.selecionarImagemUpload(tipoBanner.valor, index, 'desktop')),
                                            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                                            onDrop: _withModifiers(($event: any) => (_ctx.dropImagem($event, tipoBanner.valor, index, 'desktop')), ["prevent"])
                                          }, [
                                            _createElementVNode("input", {
                                              id: _ctx.montarIdUpload(tipoBanner.valor, index, 'desktop'),
                                              type: "file",
                                              accept: ".png, .jpg, .jpeg, .webp",
                                              onChange: ($event: any) => (_ctx.enviarImagem($event, tipoBanner.valor, index, 'desktop')),
                                              style: {"display":"none"}
                                            }, null, 40, _hoisted_19),
                                            (_ctx.state.enviandoImagem)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                  _createVNode(_component_a_spin),
                                                  _hoisted_21
                                                ]))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  (element.imagemDesktop)
                                                    ? (_openBlock(), _createBlock(_component_a_image, {
                                                        key: 0,
                                                        src: element.imagemDesktop,
                                                        preview: { src: element.imagemDesktop },
                                                        class: "ui-banner-preview",
                                                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                                      }, null, 8, ["src", "preview"]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                        _createVNode(_component_icone, { nome: "upload-nuvem" }),
                                                        _hoisted_23,
                                                        _hoisted_24
                                                      ]))
                                                ], 64))
                                          ], 42, _hoisted_18)
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _hoisted_26,
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["ui-banner-upload", { 'ui-banner-upload-vazio': !element.imagemMobile }]),
                                            onClick: ($event: any) => (_ctx.selecionarImagemUpload(tipoBanner.valor, index, 'mobile')),
                                            onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                                            onDrop: _withModifiers(($event: any) => (_ctx.dropImagem($event, tipoBanner.valor, index, 'mobile')), ["prevent"])
                                          }, [
                                            _createElementVNode("input", {
                                              id: _ctx.montarIdUpload(tipoBanner.valor, index, 'mobile'),
                                              type: "file",
                                              accept: ".png, .jpg, .jpeg, .webp",
                                              onChange: ($event: any) => (_ctx.enviarImagem($event, tipoBanner.valor, index, 'mobile')),
                                              style: {"display":"none"}
                                            }, null, 40, _hoisted_28),
                                            (_ctx.state.enviandoImagem)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                  _createVNode(_component_a_spin),
                                                  _hoisted_30
                                                ]))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  (element.imagemMobile)
                                                    ? (_openBlock(), _createBlock(_component_a_image, {
                                                        key: 0,
                                                        src: element.imagemMobile,
                                                        preview: { src: element.imagemMobile },
                                                        class: "ui-banner-preview",
                                                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                                      }, null, 8, ["src", "preview"]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                        _createVNode(_component_icone, { nome: "upload-nuvem" }),
                                                        _hoisted_32,
                                                        _hoisted_33
                                                      ]))
                                                ], 64))
                                          ], 42, _hoisted_27)
                                        ]),
                                        _createElementVNode("div", _hoisted_34, [
                                          _createVNode(_component_a_form, { layout: "vertical" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, { label: "Descrição" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_textarea, {
                                                    value: element.descricao,
                                                    "onUpdate:value": ($event: any) => ((element.descricao) = $event),
                                                    rows: 3,
                                                    placeholder: "Descrição opcional do banner"
                                                  }, null, 8, ["value", "onUpdate:value"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_a_form_item, { label: "Link obrigatório" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_input, {
                                                    value: element.link,
                                                    "onUpdate:value": ($event: any) => ((element.link) = $event),
                                                    placeholder: "Informe o link"
                                                  }, null, 8, ["value", "onUpdate:value"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_a_form_item, { label: "Destino" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_select, {
                                                    value: element.destino,
                                                    "onUpdate:value": ($event: any) => ((element.destino) = $event)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_select_option, {
                                                        value: _ctx.EDestinoBanner.MesmaPagina
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Abrir na mesma página ")
                                                        ]),
                                                        _: 1
                                                      }, 8, ["value"]),
                                                      _createVNode(_component_a_select_option, {
                                                        value: _ctx.EDestinoBanner.NovaAba
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Abrir em nova aba ")
                                                        ]),
                                                        _: 1
                                                      }, 8, ["value"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value", "onUpdate:value"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onEnd"]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_a_button, {
                                    onClick: ($event: any) => (_ctx.adicionarBanner(tipoBanner.valor))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Adicionar banner ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    loading: _ctx.state.salvandoTipo === tipoBanner.valor,
                                    onClick: ($event: any) => (_ctx.salvarBanners(tipoBanner.valor))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Salvar ")
                                    ]),
                                    _: 2
                                  }, 1032, ["loading", "onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["header"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}